
export const sizeChartData = {
    columns: [
        {
            title: "Pending Units",
            children: [
                {
                    title: "T-Jacket",
                    dataIndex: "stage",
                    key: "stage",
                    width: 75,
                    children: [
                        {
                            title: "Shirt/RTW-P",
                            dataIndex: "stage",
                            key: "stage",
                            width: 75,
                            children: [
                                {
                                    title: "Shirt/RTW-R",
                                    dataIndex: "stage",
                                    key: "stage",
                                    width: 75,
                                    children: [
                                        {
                                            title: "Y-Adult",
                                            dataIndex: "stage",
                                            key: "stage",
                                            width: 75,
                                            children: [
                                                {
                                                    title: "W-Plus",
                                                    dataIndex: "stage",
                                                    key: "stage",
                                                    width: 75,
                                                    children: [
                                                        {
                                                            title: "Kids",
                                                            dataIndex: "stage",
                                                            key: "stage",
                                                            width: 75,
                                                            children: [
                                                                {
                                                                    title: "Men",
                                                                    dataIndex: "stage",
                                                                    key: "stage",
                                                                    width: 75,
                                                                    children: [
                                                                        {
                                                                            title: "Women",
                                                                            dataIndex: "stage",
                                                                            key: "stage",
                                                                            width: 80,
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"2/3"',
                    align: "right",
                    dataIndex: "qty_1",
                    key: "qty_1",
                    width: 40,
                    children: [
                        {
                            title: "1XL",
                            dataIndex: "qty_1",
                            key: "qty_1",
                            width: 40,
                            align: "right",
                            children: [
                                {
                                    title: "XXS",
                                    dataIndex: "qty_1",
                                    key: "qty_1",
                                    width: 40,
                                    align: "right",
                                    children: [
                                        {
                                            title: "00",
                                            dataIndex: "qty_1",
                                            key: "qty_1",
                                            width: 40,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "10W",
                                                    dataIndex: "qty_1",
                                                    key: "qty_1",
                                                    width: 40,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "2",
                                                            dataIndex: "qty_1",
                                                            key: "qty_1",
                                                            width: 40,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "27",
                                                                    dataIndex: "qty_1",
                                                                    key: "qty_1",
                                                                    align: "right",
                                                                    width: 40,
                                                                    children: [
                                                                        {
                                                                            title: "22",
                                                                            dataIndex: "qty_1",
                                                                            key: "qty_1",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"4/5"',
                    align: "right",
                    dataIndex: "qty_2",
                    key: "qty_2",
                    width: 50,
                    children: [
                        {
                            title: "2XL",
                            align: "right",
                            dataIndex: "qty_2",
                            key: "qty_2",
                            width: 55,
                            children: [
                                {
                                    title: "XS",
                                    align: "right",
                                    dataIndex: "qty_2",
                                    key: "qty_2",
                                    width: 55,
                                    children: [
                                        {
                                            title: "0",
                                            align: "right",
                                            dataIndex: "qty_2",
                                            key: "qty_2",
                                            width: 55,
                                            children: [
                                                {
                                                    title: "12W",
                                                    align: "right",
                                                    dataIndex: "qty_2",
                                                    key: "qty_2",
                                                    width: 55,
                                                    children: [
                                                        {
                                                            title: "3",
                                                            align: "right",
                                                            dataIndex: "qty_2",
                                                            key: "qty_2",
                                                            width: 50,
                                                            children: [
                                                                {
                                                                    title: "28",
                                                                    align: "right",
                                                                    dataIndex: "qty_2",
                                                                    key: "qty_2",
                                                                    width: 50,
                                                                    children: [
                                                                        {
                                                                            title: "23",
                                                                            align: "right",
                                                                            dataIndex: "qty_2",
                                                                            key: "qty_2",
                                                                            width: 40,
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"6/6X"',
                    dataIndex: "qty_3",
                    key: "qty_3",
                    align: "right",
                    width: 60,
                    children: [
                        {
                            title: "3XL",
                            dataIndex: "qty_3",
                            key: "qty_3",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "S",
                                    dataIndex: "qty_3",
                                    key: "qty_3",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "1",
                                            dataIndex: "qty_3",
                                            key: "qty_3",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "14W",
                                                    dataIndex: "qty_3",
                                                    key: "qty_3",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "4",
                                                            dataIndex: "qty_3",
                                                            key: "qty_3",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "29",
                                                                    dataIndex: "qty_3",
                                                                    key: "qty_3",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "24",
                                                                            dataIndex: "qty_3",
                                                                            key: "qty_3",
                                                                            width: 45,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"7/8"',
                    dataIndex: "qty_4",
                    key: "qty_4",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_4",
                            key: "qty_4",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "M",
                                    dataIndex: "qty_4",
                                    key: "qty_4",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "2",
                                            dataIndex: "qty_4",
                                            key: "qty_4",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "16W",
                                                    dataIndex: "qty_4",
                                                    key: "qty_4",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "5",
                                                            dataIndex: "qty_4",
                                                            key: "qty_4",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "30",
                                                                    dataIndex: "qty_4",
                                                                    key: "qty_4",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "25",
                                                                            dataIndex: "qty_4",
                                                                            key: "qty_4",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"9/10"',
                    dataIndex: "qty_5",
                    key: "qty_5",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_5",
                            key: "qty_5",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "L",
                                    dataIndex: "qty_5",
                                    key: "qty_5",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "3",
                                            dataIndex: "qty_5",
                                            key: "qty_5",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "18W",
                                                    dataIndex: "qty_5",
                                                    key: "qty_5",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "6",
                                                            dataIndex: "qty_5",
                                                            key: "qty_5",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "31",
                                                                    dataIndex: "qty_5",
                                                                    key: "qty_5",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "26",
                                                                            dataIndex: "qty_5",
                                                                            key: "qty_5",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"11/12"',
                    dataIndex: "qty_6",
                    key: "qty_6",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_6",
                            key: "qty_6",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "XL",
                                    dataIndex: "qty_6",
                                    key: "qty_6",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "4",
                                            dataIndex: "qty_6",
                                            key: "qty_6",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "20W",
                                                    dataIndex: "qty_6",
                                                    key: "qty_6",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "6x",
                                                            dataIndex: "qty_6",
                                                            key: "qty_6",
                                                            width: 50,
                                                            align: "right",

                                                            children: [
                                                                {
                                                                    title: "32",
                                                                    dataIndex: "qty_6",
                                                                    key: "qty_6",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "27",
                                                                            dataIndex: "qty_6",
                                                                            key: "qty_6",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"13/14"',
                    dataIndex: "qty_7",
                    key: "qty_7",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_7",
                            key: "qty_7",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "XXL",
                                    dataIndex: "qty_7",
                                    key: "qty_7",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "5",
                                            dataIndex: "qty_7",
                                            key: "qty_7",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "22W",
                                                    dataIndex: "qty_7",
                                                    key: "qty_7",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "7",
                                                            dataIndex: "qty_7",
                                                            key: "qty_7",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "33",
                                                                    dataIndex: "qty_7",
                                                                    key: "qty_7",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "28",
                                                                            dataIndex: "qty_7",
                                                                            key: "qty_7",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"15/16"',
                    dataIndex: "qty_8",
                    key: "qty_8",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_8",
                            key: "qty_8",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_8",
                                    key: "qty_8",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "6",
                                            dataIndex: "qty_8",
                                            key: "qty_8",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "24W",
                                                    dataIndex: "qty_8",
                                                    key: "qty_8",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "7x",
                                                            dataIndex: "qty_8",
                                                            key: "qty_8",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "34",
                                                                    dataIndex: "qty_8",
                                                                    key: "qty_8",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "29",
                                                                            dataIndex: "qty_8",
                                                                            key: "qty_8",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }
                            ]
                        }]
                },
                {
                    title: "-",
                    dataIndex: "qty_9",
                    key: "qty_9",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_9",
                            key: "qty_9",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_9",
                                    key: "qty_9",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "7",
                                            dataIndex: "qty_9",
                                            key: "qty_9",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "26W",
                                                    dataIndex: "qty_9",
                                                    key: "qty_9",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "8",
                                                            dataIndex: "qty_9",
                                                            key: "qty_9",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "35",
                                                                    dataIndex: "qty_9",
                                                                    key: "qty_9",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "30",
                                                                            dataIndex: "qty_9",
                                                                            key: "qty_9",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_10",
                    key: "qty_10",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_10",
                            key: "qty_10",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_10",
                                    key: "qty_10",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "8",
                                            dataIndex: "qty_10",
                                            key: "qty_10",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "28W",
                                                    dataIndex: "qty_10",
                                                    key: "qty_10",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "10",
                                                            dataIndex: "qty_10",
                                                            key: "qty_10",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "36",
                                                                    dataIndex: "qty_10",
                                                                    key: "qty_10",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "31",
                                                                            dataIndex: "qty_10",
                                                                            key: "qty_10",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_11",
                    key: "qty_11",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_11",
                            key: "qty_11",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_11",
                                    key: "qty_11",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "9",
                                            dataIndex: "qty_11",
                                            key: "qty_11",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "30W",
                                                    dataIndex: "qty_11",
                                                    key: "qty_11",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "12",
                                                            dataIndex: "qty_11",
                                                            key: "qty_11",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "38",
                                                                    dataIndex: "qty_11",
                                                                    key: "qty_11",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "32",
                                                                            dataIndex: "qty_11",
                                                                            key: "qty_11",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_12",
                    key: "qty_12",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_12",
                            key: "qty_12",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_12",
                                    key: "qty_12",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "10",
                                            dataIndex: "qty_12",
                                            key: "qty_12",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "32W",
                                                    dataIndex: "qty_12",
                                                    key: "qty_12",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "14",
                                                            dataIndex: "qty_12",
                                                            key: "qty_12",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "40",
                                                                    dataIndex: "qty_12",
                                                                    key: "qty_12",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "33",
                                                                            dataIndex: "qty_12",
                                                                            key: "qty_12",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_13",
                    key: "qty_13",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_13",
                            key: "qty_13",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_13",
                                    key: "qty_13",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_13",
                                            key: "qty_13",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_13",
                                                    key: "qty_13",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "16",
                                                            dataIndex: "qty_13",
                                                            key: "qty_13",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "42",
                                                                    dataIndex: "qty_13",
                                                                    key: "qty_13",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "34",
                                                                            dataIndex: "qty_13",
                                                                            key: "qty_13",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_14",
                    key: "qty_14",
                    width: 50,
                    align: "right",

                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_14",
                            key: "qty_14",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_14",
                                    key: "qty_14",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_14",
                                            key: "qty_14",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_14",
                                                    key: "qty_14",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "18",
                                                            dataIndex: "qty_14",
                                                            key: "qty_14",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "44",
                                                                    dataIndex: "qty_14",
                                                                    key: "qty_14",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "35",
                                                                            dataIndex: "qty_14",
                                                                            key: "qty_14",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        }
                                    ]
                                }]
                        },
                    ],
                },
                {
                    title: "-",
                    dataIndex: "qty_15",
                    key: "qty_15",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_15",
                            key: "qty_15",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_15",
                                    key: "qty_15",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_15",
                                            key: "qty_15",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_15",
                                                    key: "qty_15",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "20",
                                                            dataIndex: "qty_15",
                                                            key: "qty_15",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "46",
                                                                    dataIndex: "qty_15",
                                                                    key: "qty_15",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "36",
                                                                            dataIndex: "qty_15",
                                                                            key: "qty_15",
                                                                            width: 40,
                                                                            align: "right",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_16",
                    key: "qty_16",
                    width: 50,
                    align: "right",
                    // className: "Border-Right-table border-z-index-1",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_16",
                            key: "qty_16",
                            width: 50,
                            align: "right",
                            // className: "Border-Right-table border-z-index-1",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_16",
                                    key: "qty_16",
                                    width: 50,
                                    align: "right",
                                    // className: "Border-Right-table border-z-index-1",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_16",
                                            key: "qty_16",
                                            width: 50,
                                            align: "right",
                                            // className: "Border-Right-table border-z-index-1",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_16",
                                                    key: "qty_16",
                                                    width: 50,
                                                    align: "right",
                                                    // className: "Border-Right-table border-z-index-1",
                                                    children: [
                                                        {
                                                            title: "-",
                                                            dataIndex: "qty_16",
                                                            key: "qty_16",
                                                            width: 50,
                                                            align: "right",
                                                            // className: "Border-Right-table border-z-index-1",
                                                            children: [
                                                                {
                                                                    title: "48",
                                                                    dataIndex: "qty_16",
                                                                    key: "qty_16",
                                                                    width: 50,
                                                                    align: "right",
                                                                    // className: "Border-Right-table border-z-index-1",
                                                                    children: [
                                                                        {
                                                                            title: "37",
                                                                            dataIndex: "qty_16",
                                                                            key: "qty_16",
                                                                            width: 40,
                                                                            align: "right",
                                                                            // className: "Border-Right-table border-z-index-1",
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }
                            ]
                        }
                    ]
                },
            ],
        }
    ],
};



export const sizeChartDataNew = {
    columns: [
        {
            children: [
                {
                    title: "T-Jacket",
                    dataIndex: "stage",
                    key: "stage",
                    width: 75,
                    children: [
                        {
                            title: "Shirt/RTW-P",
                            dataIndex: "stage",
                            key: "stage",
                            width: 75,
                            children: [
                                {
                                    title: "Shirt/RTW-R",
                                    dataIndex: "stage",
                                    key: "stage",
                                    width: 75,
                                    children: [
                                        {
                                            title: "Y-Adult",
                                            dataIndex: "stage",
                                            key: "stage",
                                            width: 75,
                                            children: [
                                                {
                                                    title: "W-Plus",
                                                    dataIndex: "stage",
                                                    key: "stage",
                                                    width: 75,
                                                    children: [
                                                        {
                                                            title: "Kids",
                                                            dataIndex: "stage",
                                                            key: "stage",
                                                            width: 75,
                                                            children: [
                                                                {
                                                                    title: "Men",
                                                                    dataIndex: "stage",
                                                                    key: "stage",
                                                                    width: 75,
                                                                    children: [
                                                                        {
                                                                            title: "Women",
                                                                            dataIndex: "stage",
                                                                            key: "stage",
                                                                            width: 80,
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"2/3"',
                    align: "right",
                    dataIndex: "qty_1",
                    key: "qty_1",
                    width: 40,
                    children: [
                        {
                            title: "1XL",
                            dataIndex: "qty_1",
                            key: "qty_1",
                            width: 40,
                            align: "right",
                            children: [
                                {
                                    title: "XXS",
                                    dataIndex: "qty_1",
                                    key: "qty_1",
                                    width: 40,
                                    align: "right",
                                    children: [
                                        {
                                            title: "00",
                                            dataIndex: "qty_1",
                                            key: "qty_1",
                                            width: 40,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "10W",
                                                    dataIndex: "qty_1",
                                                    key: "qty_1",
                                                    width: 40,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "2",
                                                            dataIndex: "qty_1",
                                                            key: "qty_1",
                                                            width: 40,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "27",
                                                                    dataIndex: "qty_1",
                                                                    key: "qty_1",
                                                                    align: "right",
                                                                    width: 40,
                                                                    children: [
                                                                        {
                                                                            title: "22",
                                                                            dataIndex: "qty_1",
                                                                            key: "qty_1",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"4/5"',
                    align: "right",
                    dataIndex: "qty_2",
                    key: "qty_2",
                    width: 50,
                    children: [
                        {
                            title: "2XL",
                            align: "right",
                            dataIndex: "qty_2",
                            key: "qty_2",
                            width: 55,
                            children: [
                                {
                                    title: "XS",
                                    align: "right",
                                    dataIndex: "qty_2",
                                    key: "qty_2",
                                    width: 55,
                                    children: [
                                        {
                                            title: "0",
                                            align: "right",
                                            dataIndex: "qty_2",
                                            key: "qty_2",
                                            width: 55,
                                            children: [
                                                {
                                                    title: "12W",
                                                    align: "right",
                                                    dataIndex: "qty_2",
                                                    key: "qty_2",
                                                    width: 55,
                                                    children: [
                                                        {
                                                            title: "3",
                                                            align: "right",
                                                            dataIndex: "qty_2",
                                                            key: "qty_2",
                                                            width: 50,
                                                            children: [
                                                                {
                                                                    title: "28",
                                                                    align: "right",
                                                                    dataIndex: "qty_2",
                                                                    key: "qty_2",
                                                                    width: 50,
                                                                    children: [
                                                                        {
                                                                            title: "23",
                                                                            align: "right",
                                                                            dataIndex: "qty_2",
                                                                            key: "qty_2",
                                                                            width: 40,
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"6/6X"',
                    dataIndex: "qty_3",
                    key: "qty_3",
                    align: "right",
                    width: 60,
                    children: [
                        {
                            title: "3XL",
                            dataIndex: "qty_3",
                            key: "qty_3",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "S",
                                    dataIndex: "qty_3",
                                    key: "qty_3",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "1",
                                            dataIndex: "qty_3",
                                            key: "qty_3",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "14W",
                                                    dataIndex: "qty_3",
                                                    key: "qty_3",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "4",
                                                            dataIndex: "qty_3",
                                                            key: "qty_3",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "29",
                                                                    dataIndex: "qty_3",
                                                                    key: "qty_3",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "24",
                                                                            dataIndex: "qty_3",
                                                                            key: "qty_3",
                                                                            width: 45,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"7/8"',
                    dataIndex: "qty_4",
                    key: "qty_4",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_4",
                            key: "qty_4",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "M",
                                    dataIndex: "qty_4",
                                    key: "qty_4",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "2",
                                            dataIndex: "qty_4",
                                            key: "qty_4",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "16W",
                                                    dataIndex: "qty_4",
                                                    key: "qty_4",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "5",
                                                            dataIndex: "qty_4",
                                                            key: "qty_4",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "30",
                                                                    dataIndex: "qty_4",
                                                                    key: "qty_4",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "25",
                                                                            dataIndex: "qty_4",
                                                                            key: "qty_4",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"9/10"',
                    dataIndex: "qty_5",
                    key: "qty_5",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_5",
                            key: "qty_5",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "L",
                                    dataIndex: "qty_5",
                                    key: "qty_5",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "3",
                                            dataIndex: "qty_5",
                                            key: "qty_5",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "18W",
                                                    dataIndex: "qty_5",
                                                    key: "qty_5",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "6",
                                                            dataIndex: "qty_5",
                                                            key: "qty_5",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "31",
                                                                    dataIndex: "qty_5",
                                                                    key: "qty_5",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "26",
                                                                            dataIndex: "qty_5",
                                                                            key: "qty_5",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"11/12"',
                    dataIndex: "qty_6",
                    key: "qty_6",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_6",
                            key: "qty_6",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "XL",
                                    dataIndex: "qty_6",
                                    key: "qty_6",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "4",
                                            dataIndex: "qty_6",
                                            key: "qty_6",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "20W",
                                                    dataIndex: "qty_6",
                                                    key: "qty_6",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "6x",
                                                            dataIndex: "qty_6",
                                                            key: "qty_6",
                                                            width: 50,
                                                            align: "right",

                                                            children: [
                                                                {
                                                                    title: "32",
                                                                    dataIndex: "qty_6",
                                                                    key: "qty_6",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "27",
                                                                            dataIndex: "qty_6",
                                                                            key: "qty_6",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"13/14"',
                    dataIndex: "qty_7",
                    key: "qty_7",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_7",
                            key: "qty_7",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "XXL",
                                    dataIndex: "qty_7",
                                    key: "qty_7",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "5",
                                            dataIndex: "qty_7",
                                            key: "qty_7",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "22W",
                                                    dataIndex: "qty_7",
                                                    key: "qty_7",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "7",
                                                            dataIndex: "qty_7",
                                                            key: "qty_7",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "33",
                                                                    dataIndex: "qty_7",
                                                                    key: "qty_7",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "28",
                                                                            dataIndex: "qty_7",
                                                                            key: "qty_7",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"15/16"',
                    dataIndex: "qty_8",
                    key: "qty_8",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_8",
                            key: "qty_8",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_8",
                                    key: "qty_8",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "6",
                                            dataIndex: "qty_8",
                                            key: "qty_8",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "24W",
                                                    dataIndex: "qty_8",
                                                    key: "qty_8",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "7x",
                                                            dataIndex: "qty_8",
                                                            key: "qty_8",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "34",
                                                                    dataIndex: "qty_8",
                                                                    key: "qty_8",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "29",
                                                                            dataIndex: "qty_8",
                                                                            key: "qty_8",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }
                            ]
                        }]
                },
                {
                    title: "-",
                    dataIndex: "qty_9",
                    key: "qty_9",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_9",
                            key: "qty_9",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_9",
                                    key: "qty_9",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "7",
                                            dataIndex: "qty_9",
                                            key: "qty_9",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "26W",
                                                    dataIndex: "qty_9",
                                                    key: "qty_9",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "8",
                                                            dataIndex: "qty_9",
                                                            key: "qty_9",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "35",
                                                                    dataIndex: "qty_9",
                                                                    key: "qty_9",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "30",
                                                                            dataIndex: "qty_9",
                                                                            key: "qty_9",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_10",
                    key: "qty_10",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_10",
                            key: "qty_10",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_10",
                                    key: "qty_10",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "8",
                                            dataIndex: "qty_10",
                                            key: "qty_10",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "28W",
                                                    dataIndex: "qty_10",
                                                    key: "qty_10",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "10",
                                                            dataIndex: "qty_10",
                                                            key: "qty_10",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "36",
                                                                    dataIndex: "qty_10",
                                                                    key: "qty_10",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "31",
                                                                            dataIndex: "qty_10",
                                                                            key: "qty_10",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_11",
                    key: "qty_11",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_11",
                            key: "qty_11",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_11",
                                    key: "qty_11",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "9",
                                            dataIndex: "qty_11",
                                            key: "qty_11",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "30W",
                                                    dataIndex: "qty_11",
                                                    key: "qty_11",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "12",
                                                            dataIndex: "qty_11",
                                                            key: "qty_11",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "38",
                                                                    dataIndex: "qty_11",
                                                                    key: "qty_11",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "32",
                                                                            dataIndex: "qty_11",
                                                                            key: "qty_11",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_12",
                    key: "qty_12",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_12",
                            key: "qty_12",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_12",
                                    key: "qty_12",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "10",
                                            dataIndex: "qty_12",
                                            key: "qty_12",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "32W",
                                                    dataIndex: "qty_12",
                                                    key: "qty_12",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "14",
                                                            dataIndex: "qty_12",
                                                            key: "qty_12",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "40",
                                                                    dataIndex: "qty_12",
                                                                    key: "qty_12",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "33",
                                                                            dataIndex: "qty_12",
                                                                            key: "qty_12",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_13",
                    key: "qty_13",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_13",
                            key: "qty_13",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_13",
                                    key: "qty_13",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_13",
                                            key: "qty_13",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_13",
                                                    key: "qty_13",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "16",
                                                            dataIndex: "qty_13",
                                                            key: "qty_13",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "42",
                                                                    dataIndex: "qty_13",
                                                                    key: "qty_13",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "34",
                                                                            dataIndex: "qty_13",
                                                                            key: "qty_13",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_14",
                    key: "qty_14",
                    width: 50,
                    align: "right",

                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_14",
                            key: "qty_14",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_14",
                                    key: "qty_14",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_14",
                                            key: "qty_14",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_14",
                                                    key: "qty_14",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "18",
                                                            dataIndex: "qty_14",
                                                            key: "qty_14",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "44",
                                                                    dataIndex: "qty_14",
                                                                    key: "qty_14",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "35",
                                                                            dataIndex: "qty_14",
                                                                            key: "qty_14",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }

                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        }
                                    ]
                                }]
                        },
                    ],
                },
                {
                    title: "-",
                    dataIndex: "qty_15",
                    key: "qty_15",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_15",
                            key: "qty_15",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_15",
                                    key: "qty_15",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_15",
                                            key: "qty_15",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_15",
                                                    key: "qty_15",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "20",
                                                            dataIndex: "qty_15",
                                                            key: "qty_15",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "46",
                                                                    dataIndex: "qty_15",
                                                                    key: "qty_15",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "36",
                                                                            dataIndex: "qty_15",
                                                                            key: "qty_15",
                                                                            width: 40,
                                                                            align: "right",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_16",
                    key: "qty_16",
                    width: 50,
                    align: "right",
                    // className: "Border-Right-table border-z-index-1",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_16",
                            key: "qty_16",
                            width: 50,
                            align: "right",
                            // className: "Border-Right-table border-z-index-1",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_16",
                                    key: "qty_16",
                                    width: 50,
                                    align: "right",
                                    // className: "Border-Right-table border-z-index-1",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_16",
                                            key: "qty_16",
                                            width: 50,
                                            align: "right",
                                            // className: "Border-Right-table border-z-index-1",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_16",
                                                    key: "qty_16",
                                                    width: 50,
                                                    align: "right",
                                                    // className: "Border-Right-table border-z-index-1",
                                                    children: [
                                                        {
                                                            title: "-",
                                                            dataIndex: "qty_16",
                                                            key: "qty_16",
                                                            width: 50,
                                                            align: "right",
                                                            // className: "Border-Right-table border-z-index-1",
                                                            children: [
                                                                {
                                                                    title: "48",
                                                                    dataIndex: "qty_16",
                                                                    key: "qty_16",
                                                                    width: 50,
                                                                    align: "right",
                                                                    // className: "Border-Right-table border-z-index-1",
                                                                    children: [
                                                                        {
                                                                            title: "37",
                                                                            dataIndex: "qty_16",
                                                                            key: "qty_16",
                                                                            width: 40,
                                                                            align: "right",
                                                                            // className: "Border-Right-table border-z-index-1",
                                                                            render: (text) => {
                                                                                if (!text) return null;

                                                                                const [main, bracket] = text.split(/[()]/); // split by "(" or ")"
                                                                                const mainValue = parseInt(main);
                                                                                const bracketValue = parseInt(bracket);

                                                                                // Case: 0(0)
                                                                                if (mainValue === 0 && bracketValue === 0) {
                                                                                    return "0";
                                                                                }

                                                                                return (
                                                                                    <span>
                                                                                        {mainValue}
                                                                                        {bracketValue !== 0 && !isNaN(bracketValue) ? (
                                                                                            <span style={{ color: "red" }}>({bracketValue})</span>
                                                                                        ) : null}
                                                                                    </span>
                                                                                );
                                                                            }
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }
                            ]
                        }
                    ]
                },
            ],
        }
    ],
};


export const sizeCurveChart = {
    columns: [
        {
            children: [
                {
                    title: "T-Jacket",
                    dataIndex: "stage",
                    key: "stage",
                    width: 75,
                    children: [
                        {
                            title: "Shirt/RTW-P",
                            dataIndex: "stage",
                            key: "stage",
                            width: 75,
                            children: [
                                {
                                    title: "Shirt/RTW-R",
                                    dataIndex: "stage",
                                    key: "stage",
                                    width: 75,
                                    children: [
                                        {
                                            title: "Y-Adult",
                                            dataIndex: "stage",
                                            key: "stage",
                                            width: 75,
                                            children: [
                                                {
                                                    title: "W-Plus",
                                                    dataIndex: "stage",
                                                    key: "stage",
                                                    width: 75,
                                                    children: [
                                                        {
                                                            title: "Kids",
                                                            dataIndex: "stage",
                                                            key: "stage",
                                                            width: 75,
                                                            children: [
                                                                {
                                                                    title: "Men",
                                                                    dataIndex: "stage",
                                                                    key: "stage",
                                                                    width: 75,
                                                                    children: [
                                                                        {
                                                                            title: "Women",
                                                                            dataIndex: "stage",
                                                                            key: "stage",
                                                                            width: 80,
                                                                            children: [
                                                                                {
                                                                                    title: "Women Petite",
                                                                                    dataIndex: "stage",
                                                                                    key: "stage",
                                                                                    width: 90,
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"2/3"',
                    align: "right",
                    dataIndex: "qty_1",
                    key: "qty_1",
                    width: 40,
                    children: [
                        {
                            title: "1XL",
                            dataIndex: "qty_1",
                            key: "qty_1",
                            width: 40,
                            align: "right",
                            children: [
                                {
                                    title: "XXS",
                                    dataIndex: "qty_1",
                                    key: "qty_1",
                                    width: 40,
                                    align: "right",
                                    children: [
                                        {
                                            title: "00",
                                            dataIndex: "qty_1",
                                            key: "qty_1",
                                            width: 40,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "10W",
                                                    dataIndex: "qty_1",
                                                    key: "qty_1",
                                                    width: 40,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "2",
                                                            dataIndex: "qty_1",
                                                            key: "qty_1",
                                                            width: 40,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "27",
                                                                    dataIndex: "qty_1",
                                                                    key: "qty_1",
                                                                    align: "right",
                                                                    width: 40,
                                                                    children: [
                                                                        {
                                                                            title: "22",
                                                                            dataIndex: "qty_1",
                                                                            key: "qty_1",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "22P",
                                                                                    dataIndex: "qty_1",
                                                                                    key: "qty_1",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"4/5"',
                    align: "right",
                    dataIndex: "qty_2",
                    key: "qty_2",
                    width: 50,
                    children: [
                        {
                            title: "2XL",
                            align: "right",
                            dataIndex: "qty_2",
                            key: "qty_2",
                            width: 55,
                            children: [
                                {
                                    title: "XS",
                                    align: "right",
                                    dataIndex: "qty_2",
                                    key: "qty_2",
                                    width: 55,
                                    children: [
                                        {
                                            title: "0",
                                            align: "right",
                                            dataIndex: "qty_2",
                                            key: "qty_2",
                                            width: 55,
                                            children: [
                                                {
                                                    title: "12W",
                                                    align: "right",
                                                    dataIndex: "qty_2",
                                                    key: "qty_2",
                                                    width: 55,
                                                    children: [
                                                        {
                                                            title: "3",
                                                            align: "right",
                                                            dataIndex: "qty_2",
                                                            key: "qty_2",
                                                            width: 50,
                                                            children: [
                                                                {
                                                                    title: "28",
                                                                    align: "right",
                                                                    dataIndex: "qty_2",
                                                                    key: "qty_2",
                                                                    width: 50,
                                                                    children: [
                                                                        {
                                                                            title: "23",
                                                                            align: "right",
                                                                            dataIndex: "qty_2",
                                                                            key: "qty_2",
                                                                            width: 40,
                                                                            children: [
                                                                                {
                                                                                    title: "23P",
                                                                                    align: "right",
                                                                                    dataIndex: "qty_2",
                                                                                    key: "qty_2",
                                                                                    width: 40,

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"6/6X"',
                    dataIndex: "qty_3",
                    key: "qty_3",
                    align: "right",
                    width: 60,
                    children: [
                        {
                            title: "3XL",
                            dataIndex: "qty_3",
                            key: "qty_3",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "S",
                                    dataIndex: "qty_3",
                                    key: "qty_3",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "1",
                                            dataIndex: "qty_3",
                                            key: "qty_3",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "14W",
                                                    dataIndex: "qty_3",
                                                    key: "qty_3",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "4",
                                                            dataIndex: "qty_3",
                                                            key: "qty_3",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "29",
                                                                    dataIndex: "qty_3",
                                                                    key: "qty_3",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "24",
                                                                            dataIndex: "qty_3",
                                                                            key: "qty_3",
                                                                            width: 45,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "24P",
                                                                                    dataIndex: "qty_3",
                                                                                    key: "qty_3",
                                                                                    width: 45,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_4",
                    key: "qty_4",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_4",
                            key: "qty_4",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "M",
                                    dataIndex: "qty_4",
                                    key: "qty_4",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "2",
                                            dataIndex: "qty_4",
                                            key: "qty_4",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "16W",
                                                    dataIndex: "qty_4",
                                                    key: "qty_4",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "5",
                                                            dataIndex: "qty_4",
                                                            key: "qty_4",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "30",
                                                                    dataIndex: "qty_4",
                                                                    key: "qty_4",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "25",
                                                                            dataIndex: "qty_4",
                                                                            key: "qty_4",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "25P",
                                                                                    dataIndex: "qty_4",
                                                                                    key: "qty_4",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_5",
                    key: "qty_5",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_5",
                            key: "qty_5",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "L",
                                    dataIndex: "qty_5",
                                    key: "qty_5",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "3",
                                            dataIndex: "qty_5",
                                            key: "qty_5",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "18W",
                                                    dataIndex: "qty_5",
                                                    key: "qty_5",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "6",
                                                            dataIndex: "qty_5",
                                                            key: "qty_5",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "31",
                                                                    dataIndex: "qty_5",
                                                                    key: "qty_5",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "26",
                                                                            dataIndex: "qty_5",
                                                                            key: "qty_5",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "26P",
                                                                                    dataIndex: "qty_5",
                                                                                    key: "qty_5",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_6",
                    key: "qty_6",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_6",
                            key: "qty_6",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "XL",
                                    dataIndex: "qty_6",
                                    key: "qty_6",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "4",
                                            dataIndex: "qty_6",
                                            key: "qty_6",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "20W",
                                                    dataIndex: "qty_6",
                                                    key: "qty_6",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "6x",
                                                            dataIndex: "qty_6",
                                                            key: "qty_6",
                                                            width: 50,
                                                            align: "right",

                                                            children: [
                                                                {
                                                                    title: "32",
                                                                    dataIndex: "qty_6",
                                                                    key: "qty_6",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "27",
                                                                            dataIndex: "qty_6",
                                                                            key: "qty_6",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "27P",
                                                                                    dataIndex: "qty_6",
                                                                                    key: "qty_6",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_7",
                    key: "qty_7",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_7",
                            key: "qty_7",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "XXL",
                                    dataIndex: "qty_7",
                                    key: "qty_7",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "5",
                                            dataIndex: "qty_7",
                                            key: "qty_7",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "22W",
                                                    dataIndex: "qty_7",
                                                    key: "qty_7",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "7",
                                                            dataIndex: "qty_7",
                                                            key: "qty_7",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "33",
                                                                    dataIndex: "qty_7",
                                                                    key: "qty_7",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "28",
                                                                            dataIndex: "qty_7",
                                                                            key: "qty_7",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "28P",
                                                                                    dataIndex: "qty_7",
                                                                                    key: "qty_7",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_8",
                    key: "qty_8",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_8",
                            key: "qty_8",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_8",
                                    key: "qty_8",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "6",
                                            dataIndex: "qty_8",
                                            key: "qty_8",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "24W",
                                                    dataIndex: "qty_8",
                                                    key: "qty_8",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "7x",
                                                            dataIndex: "qty_8",
                                                            key: "qty_8",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "34",
                                                                    dataIndex: "qty_8",
                                                                    key: "qty_8",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "29",
                                                                            dataIndex: "qty_8",
                                                                            key: "qty_8",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "29P",
                                                                                    dataIndex: "qty_8",
                                                                                    key: "qty_8",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }
                            ]
                        }]
                },
                {
                    title: "-",
                    dataIndex: "qty_9",
                    key: "qty_9",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_9",
                            key: "qty_9",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_9",
                                    key: "qty_9",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "7",
                                            dataIndex: "qty_9",
                                            key: "qty_9",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "26W",
                                                    dataIndex: "qty_9",
                                                    key: "qty_9",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "8",
                                                            dataIndex: "qty_9",
                                                            key: "qty_9",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "35",
                                                                    dataIndex: "qty_9",
                                                                    key: "qty_9",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "30",
                                                                            dataIndex: "qty_9",
                                                                            key: "qty_9",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "30P",
                                                                                    dataIndex: "qty_9",
                                                                                    key: "qty_9",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_10",
                    key: "qty_10",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_10",
                            key: "qty_10",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_10",
                                    key: "qty_10",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "8",
                                            dataIndex: "qty_10",
                                            key: "qty_10",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "28W",
                                                    dataIndex: "qty_10",
                                                    key: "qty_10",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "10",
                                                            dataIndex: "qty_10",
                                                            key: "qty_10",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "36",
                                                                    dataIndex: "qty_10",
                                                                    key: "qty_10",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "31",
                                                                            dataIndex: "qty_10",
                                                                            key: "qty_10",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "31P",
                                                                                    dataIndex: "qty_10",
                                                                                    key: "qty_10",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_11",
                    key: "qty_11",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_11",
                            key: "qty_11",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_11",
                                    key: "qty_11",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "9",
                                            dataIndex: "qty_11",
                                            key: "qty_11",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "30W",
                                                    dataIndex: "qty_11",
                                                    key: "qty_11",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "12",
                                                            dataIndex: "qty_11",
                                                            key: "qty_11",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "38",
                                                                    dataIndex: "qty_11",
                                                                    key: "qty_11",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "32",
                                                                            dataIndex: "qty_11",
                                                                            key: "qty_11",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "32P",
                                                                                    dataIndex: "qty_11",
                                                                                    key: "qty_11",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_12",
                    key: "qty_12",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_12",
                            key: "qty_12",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_12",
                                    key: "qty_12",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "10",
                                            dataIndex: "qty_12",
                                            key: "qty_12",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "32W",
                                                    dataIndex: "qty_12",
                                                    key: "qty_12",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "14",
                                                            dataIndex: "qty_12",
                                                            key: "qty_12",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "40",
                                                                    dataIndex: "qty_12",
                                                                    key: "qty_12",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "33",
                                                                            dataIndex: "qty_12",
                                                                            key: "qty_12",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "33P",
                                                                                    dataIndex: "qty_12",
                                                                                    key: "qty_12",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_13",
                    key: "qty_13",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_13",
                            key: "qty_13",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_13",
                                    key: "qty_13",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_13",
                                            key: "qty_13",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_13",
                                                    key: "qty_13",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "16",
                                                            dataIndex: "qty_13",
                                                            key: "qty_13",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "42",
                                                                    dataIndex: "qty_13",
                                                                    key: "qty_13",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "34",
                                                                            dataIndex: "qty_13",
                                                                            key: "qty_13",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "34P",
                                                                                    dataIndex: "qty_13",
                                                                                    key: "qty_13",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_14",
                    key: "qty_14",
                    width: 50,
                    align: "right",

                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_14",
                            key: "qty_14",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_14",
                                    key: "qty_14",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_14",
                                            key: "qty_14",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_14",
                                                    key: "qty_14",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "18",
                                                            dataIndex: "qty_14",
                                                            key: "qty_14",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "44",
                                                                    dataIndex: "qty_14",
                                                                    key: "qty_14",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "35",
                                                                            dataIndex: "qty_14",
                                                                            key: "qty_14",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "35P",
                                                                                    dataIndex: "qty_14",
                                                                                    key: "qty_14",
                                                                                    width: 40,
                                                                                    align: "right",


                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        }
                                    ]
                                }]
                        },
                    ],
                },
                {
                    title: "-",
                    dataIndex: "qty_15",
                    key: "qty_15",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_15",
                            key: "qty_15",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_15",
                                    key: "qty_15",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_15",
                                            key: "qty_15",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_15",
                                                    key: "qty_15",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "20",
                                                            dataIndex: "qty_15",
                                                            key: "qty_15",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "46",
                                                                    dataIndex: "qty_15",
                                                                    key: "qty_15",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "36",
                                                                            dataIndex: "qty_15",
                                                                            key: "qty_15",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "36P",
                                                                                    dataIndex: "qty_15",
                                                                                    key: "qty_15",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_16",
                    key: "qty_16",
                    width: 50,
                    align: "right",
                    // className: "Border-Right-table border-z-index-1",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_16",
                            key: "qty_16",
                            width: 50,
                            align: "right",
                            // className: "Border-Right-table border-z-index-1",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_16",
                                    key: "qty_16",
                                    width: 50,
                                    align: "right",
                                    // className: "Border-Right-table border-z-index-1",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_16",
                                            key: "qty_16",
                                            width: 50,
                                            align: "right",
                                            // className: "Border-Right-table border-z-index-1",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_16",
                                                    key: "qty_16",
                                                    width: 50,
                                                    align: "right",
                                                    // className: "Border-Right-table border-z-index-1",
                                                    children: [
                                                        {
                                                            title: "-",
                                                            dataIndex: "qty_16",
                                                            key: "qty_16",
                                                            width: 50,
                                                            align: "right",
                                                            // className: "Border-Right-table border-z-index-1",
                                                            children: [
                                                                {
                                                                    title: "48",
                                                                    dataIndex: "qty_16",
                                                                    key: "qty_16",
                                                                    width: 50,
                                                                    align: "right",
                                                                    // className: "Border-Right-table border-z-index-1",
                                                                    children: [
                                                                        {
                                                                            title: "37",
                                                                            dataIndex: "qty_16",
                                                                            key: "qty_16",
                                                                            width: 40,
                                                                            align: "right",
                                                                            // className: "Border-Right-table border-z-index-1",
                                                                            children: [
                                                                                {
                                                                                    title: "37P",
                                                                                    dataIndex: "qty_16",
                                                                                    key: "qty_16",
                                                                                    width: 40,
                                                                                    align: "right",

                                                                                    // className: "Border-Right-table border-z-index-1",
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }
                            ]
                        }
                    ]
                },
            ],
        }
    ],
};

export const shippedStyleWisePercentage = {
    columns: [
        {
            children: [
                {
                    title: "T-Jacket",
                    dataIndex: "stage",
                    key: "stage",
                    width: 75,
                    children: [
                        {
                            title: "Shirt/RTW-P",
                            dataIndex: "stage",
                            key: "stage",
                            width: 75,
                            children: [
                                {
                                    title: "Shirt/RTW-R",
                                    dataIndex: "stage",
                                    key: "stage",
                                    width: 75,
                                    children: [
                                        {
                                            title: "Y-Adult",
                                            dataIndex: "stage",
                                            key: "stage",
                                            width: 75,
                                            children: [
                                                {
                                                    title: "W-Plus",
                                                    dataIndex: "stage",
                                                    key: "stage",
                                                    width: 75,
                                                    children: [
                                                        {
                                                            title: "Kids",
                                                            dataIndex: "stage",
                                                            key: "stage",
                                                            width: 75,
                                                            children: [
                                                                {
                                                                    title: "Men",
                                                                    dataIndex: "stage",
                                                                    key: "stage",
                                                                    width: 75,
                                                                    children: [
                                                                        {
                                                                            title: "Women",
                                                                            dataIndex: "stage",
                                                                            key: "stage",
                                                                            width: 80,
                                                                            children: [
                                                                                {
                                                                                    title: "Women Petite",
                                                                                    dataIndex: "stage",
                                                                                    key: "stage",
                                                                                    width: 90,
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"2/3"',
                    align: "right",
                    dataIndex: "qty_1",
                    key: "qty_1",
                    width: 40,
                    children: [
                        {
                            title: "1XL",
                            dataIndex: "qty_1",
                            key: "qty_1",
                            width: 40,
                            align: "right",
                            children: [
                                {
                                    title: "XXS",
                                    dataIndex: "qty_1",
                                    key: "qty_1",
                                    width: 40,
                                    align: "right",
                                    children: [
                                        {
                                            title: "00",
                                            dataIndex: "qty_1",
                                            key: "qty_1",
                                            width: 40,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "10W",
                                                    dataIndex: "qty_1",
                                                    key: "qty_1",
                                                    width: 40,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "2",
                                                            dataIndex: "qty_1",
                                                            key: "qty_1",
                                                            width: 40,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "27",
                                                                    dataIndex: "qty_1",
                                                                    key: "qty_1",
                                                                    align: "right",
                                                                    width: 40,
                                                                    children: [
                                                                        {
                                                                            title: "22",
                                                                            dataIndex: "qty_1",
                                                                            key: "qty_1",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "22P",
                                                                                    dataIndex: "qty_1",
                                                                                    key: "qty_1",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"4/5"',
                    align: "right",
                    dataIndex: "qty_2",
                    key: "qty_2",
                    width: 50,
                    children: [
                        {
                            title: "2XL",
                            align: "right",
                            dataIndex: "qty_2",
                            key: "qty_2",
                            width: 55,
                            children: [
                                {
                                    title: "XS",
                                    align: "right",
                                    dataIndex: "qty_2",
                                    key: "qty_2",
                                    width: 55,
                                    children: [
                                        {
                                            title: "0",
                                            align: "right",
                                            dataIndex: "qty_2",
                                            key: "qty_2",
                                            width: 55,
                                            children: [
                                                {
                                                    title: "12W",
                                                    align: "right",
                                                    dataIndex: "qty_2",
                                                    key: "qty_2",
                                                    width: 55,
                                                    children: [
                                                        {
                                                            title: "3",
                                                            align: "right",
                                                            dataIndex: "qty_2",
                                                            key: "qty_2",
                                                            width: 50,
                                                            children: [
                                                                {
                                                                    title: "28",
                                                                    align: "right",
                                                                    dataIndex: "qty_2",
                                                                    key: "qty_2",
                                                                    width: 50,
                                                                    children: [
                                                                        {
                                                                            title: "23",
                                                                            align: "right",
                                                                            dataIndex: "qty_2",
                                                                            key: "qty_2",
                                                                            width: 40,
                                                                            children: [
                                                                                {
                                                                                    title: "23P",
                                                                                    align: "right",
                                                                                    dataIndex: "qty_2",
                                                                                    key: "qty_2",
                                                                                    width: 40,
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"6/6X"',
                    dataIndex: "qty_3",
                    key: "qty_3",
                    align: "right",
                    width: 60,
                    children: [
                        {
                            title: "3XL",
                            dataIndex: "qty_3",
                            key: "qty_3",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "S",
                                    dataIndex: "qty_3",
                                    key: "qty_3",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "1",
                                            dataIndex: "qty_3",
                                            key: "qty_3",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "14W",
                                                    dataIndex: "qty_3",
                                                    key: "qty_3",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "4",
                                                            dataIndex: "qty_3",
                                                            key: "qty_3",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "29",
                                                                    dataIndex: "qty_3",
                                                                    key: "qty_3",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "24",
                                                                            dataIndex: "qty_3",
                                                                            key: "qty_3",
                                                                            width: 45,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "24P",
                                                                                    dataIndex: "qty_3",
                                                                                    key: "qty_3",
                                                                                    width: 45,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_4",
                    key: "qty_4",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_4",
                            key: "qty_4",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "M",
                                    dataIndex: "qty_4",
                                    key: "qty_4",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "2",
                                            dataIndex: "qty_4",
                                            key: "qty_4",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "16W",
                                                    dataIndex: "qty_4",
                                                    key: "qty_4",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "5",
                                                            dataIndex: "qty_4",
                                                            key: "qty_4",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "30",
                                                                    dataIndex: "qty_4",
                                                                    key: "qty_4",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "25",
                                                                            dataIndex: "qty_4",
                                                                            key: "qty_4",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "25P",
                                                                                    dataIndex: "qty_4",
                                                                                    key: "qty_4",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_5",
                    key: "qty_5",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_5",
                            key: "qty_5",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "L",
                                    dataIndex: "qty_5",
                                    key: "qty_5",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "3",
                                            dataIndex: "qty_5",
                                            key: "qty_5",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "18W",
                                                    dataIndex: "qty_5",
                                                    key: "qty_5",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "6",
                                                            dataIndex: "qty_5",
                                                            key: "qty_5",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "31",
                                                                    dataIndex: "qty_5",
                                                                    key: "qty_5",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "26",
                                                                            dataIndex: "qty_5",
                                                                            key: "qty_5",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "26P",
                                                                                    dataIndex: "qty_5",
                                                                                    key: "qty_5",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_6",
                    key: "qty_6",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_6",
                            key: "qty_6",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "XL",
                                    dataIndex: "qty_6",
                                    key: "qty_6",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "4",
                                            dataIndex: "qty_6",
                                            key: "qty_6",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "20W",
                                                    dataIndex: "qty_6",
                                                    key: "qty_6",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "6x",
                                                            dataIndex: "qty_6",
                                                            key: "qty_6",
                                                            width: 50,
                                                            align: "right",

                                                            children: [
                                                                {
                                                                    title: "32",
                                                                    dataIndex: "qty_6",
                                                                    key: "qty_6",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "27",
                                                                            dataIndex: "qty_6",
                                                                            key: "qty_6",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "27P",
                                                                                    dataIndex: "qty_6",
                                                                                    key: "qty_6",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_7",
                    key: "qty_7",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_7",
                            key: "qty_7",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "XXL",
                                    dataIndex: "qty_7",
                                    key: "qty_7",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "5",
                                            dataIndex: "qty_7",
                                            key: "qty_7",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "22W",
                                                    dataIndex: "qty_7",
                                                    key: "qty_7",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "7",
                                                            dataIndex: "qty_7",
                                                            key: "qty_7",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "33",
                                                                    dataIndex: "qty_7",
                                                                    key: "qty_7",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "28",
                                                                            dataIndex: "qty_7",
                                                                            key: "qty_7",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "28P",
                                                                                    dataIndex: "qty_7",
                                                                                    key: "qty_7",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_8",
                    key: "qty_8",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_8",
                            key: "qty_8",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_8",
                                    key: "qty_8",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "6",
                                            dataIndex: "qty_8",
                                            key: "qty_8",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "24W",
                                                    dataIndex: "qty_8",
                                                    key: "qty_8",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "7x",
                                                            dataIndex: "qty_8",
                                                            key: "qty_8",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "34",
                                                                    dataIndex: "qty_8",
                                                                    key: "qty_8",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "29",
                                                                            dataIndex: "qty_8",
                                                                            key: "qty_8",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "29P",
                                                                                    dataIndex: "qty_8",
                                                                                    key: "qty_8",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }
                            ]
                        }]
                },
                {
                    title: "-",
                    dataIndex: "qty_9",
                    key: "qty_9",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_9",
                            key: "qty_9",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_9",
                                    key: "qty_9",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "7",
                                            dataIndex: "qty_9",
                                            key: "qty_9",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "26W",
                                                    dataIndex: "qty_9",
                                                    key: "qty_9",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "8",
                                                            dataIndex: "qty_9",
                                                            key: "qty_9",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "35",
                                                                    dataIndex: "qty_9",
                                                                    key: "qty_9",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "30",
                                                                            dataIndex: "qty_9",
                                                                            key: "qty_9",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "30P",
                                                                                    dataIndex: "qty_9",
                                                                                    key: "qty_9",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_10",
                    key: "qty_10",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_10",
                            key: "qty_10",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_10",
                                    key: "qty_10",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "8",
                                            dataIndex: "qty_10",
                                            key: "qty_10",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "28W",
                                                    dataIndex: "qty_10",
                                                    key: "qty_10",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "10",
                                                            dataIndex: "qty_10",
                                                            key: "qty_10",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "36",
                                                                    dataIndex: "qty_10",
                                                                    key: "qty_10",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "31",
                                                                            dataIndex: "qty_10",
                                                                            key: "qty_10",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "31P",
                                                                                    dataIndex: "qty_10",
                                                                                    key: "qty_10",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_11",
                    key: "qty_11",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_11",
                            key: "qty_11",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_11",
                                    key: "qty_11",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "9",
                                            dataIndex: "qty_11",
                                            key: "qty_11",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "30W",
                                                    dataIndex: "qty_11",
                                                    key: "qty_11",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "12",
                                                            dataIndex: "qty_11",
                                                            key: "qty_11",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "38",
                                                                    dataIndex: "qty_11",
                                                                    key: "qty_11",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "32",
                                                                            dataIndex: "qty_11",
                                                                            key: "qty_11",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "32P",
                                                                                    dataIndex: "qty_11",
                                                                                    key: "qty_11",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_12",
                    key: "qty_12",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_12",
                            key: "qty_12",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_12",
                                    key: "qty_12",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "10",
                                            dataIndex: "qty_12",
                                            key: "qty_12",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "32W",
                                                    dataIndex: "qty_12",
                                                    key: "qty_12",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "14",
                                                            dataIndex: "qty_12",
                                                            key: "qty_12",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "40",
                                                                    dataIndex: "qty_12",
                                                                    key: "qty_12",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "33",
                                                                            dataIndex: "qty_12",
                                                                            key: "qty_12",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "33P",
                                                                                    dataIndex: "qty_12",
                                                                                    key: "qty_12",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_13",
                    key: "qty_13",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_13",
                            key: "qty_13",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_13",
                                    key: "qty_13",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_13",
                                            key: "qty_13",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_13",
                                                    key: "qty_13",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "16",
                                                            dataIndex: "qty_13",
                                                            key: "qty_13",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "42",
                                                                    dataIndex: "qty_13",
                                                                    key: "qty_13",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "34",
                                                                            dataIndex: "qty_13",
                                                                            key: "qty_13",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "34P",
                                                                                    dataIndex: "qty_13",
                                                                                    key: "qty_13",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_14",
                    key: "qty_14",
                    width: 50,
                    align: "right",

                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_14",
                            key: "qty_14",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_14",
                                    key: "qty_14",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_14",
                                            key: "qty_14",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_14",
                                                    key: "qty_14",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "18",
                                                            dataIndex: "qty_14",
                                                            key: "qty_14",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "44",
                                                                    dataIndex: "qty_14",
                                                                    key: "qty_14",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "35",
                                                                            dataIndex: "qty_14",
                                                                            key: "qty_14",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "35P",
                                                                                    dataIndex: "qty_14",
                                                                                    key: "qty_14",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        }
                                    ]
                                }]
                        },
                    ],
                },
                {
                    title: "-",
                    dataIndex: "qty_15",
                    key: "qty_15",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_15",
                            key: "qty_15",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_15",
                                    key: "qty_15",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_15",
                                            key: "qty_15",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_15",
                                                    key: "qty_15",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "20",
                                                            dataIndex: "qty_15",
                                                            key: "qty_15",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "46",
                                                                    dataIndex: "qty_15",
                                                                    key: "qty_15",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "36",
                                                                            dataIndex: "qty_15",
                                                                            key: "qty_15",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "36P",
                                                                                    dataIndex: "qty_15",
                                                                                    key: "qty_15",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_16",
                    key: "qty_16",
                    width: 50,
                    align: "right",
                    // className: "Border-Right-table border-z-index-1",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_16",
                            key: "qty_16",
                            width: 50,
                            align: "right",
                            // className: "Border-Right-table border-z-index-1",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_16",
                                    key: "qty_16",
                                    width: 50,
                                    align: "right",
                                    // className: "Border-Right-table border-z-index-1",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_16",
                                            key: "qty_16",
                                            width: 50,
                                            align: "right",
                                            // className: "Border-Right-table border-z-index-1",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_16",
                                                    key: "qty_16",
                                                    width: 50,
                                                    align: "right",
                                                    // className: "Border-Right-table border-z-index-1",
                                                    children: [
                                                        {
                                                            title: "-",
                                                            dataIndex: "qty_16",
                                                            key: "qty_16",
                                                            width: 50,
                                                            align: "right",
                                                            // className: "Border-Right-table border-z-index-1",
                                                            children: [
                                                                {
                                                                    title: "48",
                                                                    dataIndex: "qty_16",
                                                                    key: "qty_16",
                                                                    width: 50,
                                                                    align: "right",
                                                                    // className: "Border-Right-table border-z-index-1",
                                                                    children: [
                                                                        {
                                                                            title: "37",
                                                                            dataIndex: "qty_16",
                                                                            key: "qty_16",
                                                                            width: 40,
                                                                            align: "right",
                                                                            // className: "Border-Right-table border-z-index-1",
                                                                            children: [
                                                                                {
                                                                                    title: "37P",
                                                                                    dataIndex: "qty_16",
                                                                                    key: "qty_16",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record, index) => {
                                                                                        return `${text} ${record.row_type === "%" ? "%" : ""}`;
                                                                                    },
                                                                                    // className: "Border-Right-table border-z-index-1",
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }
                            ]
                        }
                    ]
                },
            ],
        }
    ],
};

export const sizeCurveChartPerc = {
    columns: [
        {
            children: [
                {
                    title: '"2/3"',
                    align: "right",
                    dataIndex: "qty_1_per",
                    key: "qty_1_per",
                    width: 40,
                    children: [
                        {
                            title: "1XL",
                            dataIndex: "qty_1_per",
                            key: "qty_1_per",
                            width: 40,
                            align: "right",
                            children: [
                                {
                                    title: "XXS",
                                    dataIndex: "qty_1_per",
                                    key: "qty_1_per",
                                    width: 40,
                                    align: "right",
                                    children: [
                                        {
                                            title: "00",
                                            dataIndex: "qty_1_per",
                                            key: "qty_1_per",
                                            width: 40,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "10W",
                                                    dataIndex: "qty_1_per",
                                                    key: "qty_1_per",
                                                    width: 40,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "2",
                                                            dataIndex: "qty_1_per",
                                                            key: "qty_1_per",
                                                            width: 40,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "27",
                                                                    dataIndex: "qty_1_per",
                                                                    key: "qty_1_per",
                                                                    align: "right",
                                                                    width: 40,
                                                                    children: [
                                                                        {
                                                                            title: "22",
                                                                            dataIndex: "qty_1_per",
                                                                            key: "qty_1_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "22P",
                                                                                    dataIndex: "qty_1_per",
                                                                                    key: "qty_1_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"4/5"',
                    align: "right",
                    dataIndex: "qty_2_per",
                    key: "qty_2_per",
                    width: 50,
                    children: [
                        {
                            title: "2XL",
                            align: "right",
                            dataIndex: "qty_2_per",
                            key: "qty_2_per",
                            width: 55,
                            children: [
                                {
                                    title: "XS",
                                    align: "right",
                                    dataIndex: "qty_2_per",
                                    key: "qty_2_per",
                                    width: 55,
                                    children: [
                                        {
                                            title: "0",
                                            align: "right",
                                            dataIndex: "qty_2_per",
                                            key: "qty_2_per",
                                            width: 55,
                                            children: [
                                                {
                                                    title: "12W",
                                                    align: "right",
                                                    dataIndex: "qty_2_per",
                                                    key: "qty_2_per",
                                                    width: 55,
                                                    children: [
                                                        {
                                                            title: "3",
                                                            align: "right",
                                                            dataIndex: "qty_2_per",
                                                            key: "qty_2_per",
                                                            width: 50,
                                                            children: [
                                                                {
                                                                    title: "28",
                                                                    align: "right",
                                                                    dataIndex: "qty_2_per",
                                                                    key: "qty_2_per",
                                                                    width: 50,
                                                                    children: [
                                                                        {
                                                                            title: "23",
                                                                            align: "right",
                                                                            dataIndex: "qty_2_per",
                                                                            key: "qty_2_per",
                                                                            width: 40,
                                                                            children: [
                                                                                {
                                                                                    title: "23P",
                                                                                    align: "right",
                                                                                    dataIndex: "qty_2_per",
                                                                                    key: "qty_2_per",
                                                                                    width: 40,
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: '"6/6X"',
                    dataIndex: "qty_3_per",
                    key: "qty_3_per",
                    align: "right",
                    width: 60,
                    children: [
                        {
                            title: "3XL",
                            dataIndex: "qty_3_per",
                            key: "qty_3_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "S",
                                    dataIndex: "qty_3_per",
                                    key: "qty_3_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "1",
                                            dataIndex: "qty_3_per",
                                            key: "qty_3_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "14W",
                                                    dataIndex: "qty_3_per",
                                                    key: "qty_3_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "4",
                                                            dataIndex: "qty_3_per",
                                                            key: "qty_3_per",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "29",
                                                                    dataIndex: "qty_3_per",
                                                                    key: "qty_3_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "24",
                                                                            dataIndex: "qty_3_per",
                                                                            key: "qty_3_per",
                                                                            width: 45,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "24P",
                                                                                    dataIndex: "qty_3_per",
                                                                                    key: "qty_3_per",
                                                                                    width: 45,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_4_per",
                    key: "qty_4_per",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_4_per",
                            key: "qty_4_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "M",
                                    dataIndex: "qty_4_per",
                                    key: "qty_4_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "2",
                                            dataIndex: "qty_4_per",
                                            key: "qty_4_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "16W",
                                                    dataIndex: "qty_4_per",
                                                    key: "qty_4_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "5",
                                                            dataIndex: "qty_4_per",
                                                            key: "qty_4_per",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "30",
                                                                    dataIndex: "qty_4_per",
                                                                    key: "qty_4_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "25",
                                                                            dataIndex: "qty_4_per",
                                                                            key: "qty_4_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "25P",
                                                                                    dataIndex: "qty_4_per",
                                                                                    key: "qty_4_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_5_per",
                    key: "qty_5_per",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_5_per",
                            key: "qty_5_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "L",
                                    dataIndex: "qty_5_per",
                                    key: "qty_5_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "3",
                                            dataIndex: "qty_5_per",
                                            key: "qty_5_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "18W",
                                                    dataIndex: "qty_5_per",
                                                    key: "qty_5_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "6",
                                                            dataIndex: "qty_5_per",
                                                            key: "qty_5_per",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "31",
                                                                    dataIndex: "qty_5_per",
                                                                    key: "qty_5_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "26",
                                                                            dataIndex: "qty_5_per",
                                                                            key: "qty_5_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "26P",
                                                                                    dataIndex: "qty_5_per",
                                                                                    key: "qty_5_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_6_per",
                    key: "qty_6_per",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_6_per",
                            key: "qty_6_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "XL",
                                    dataIndex: "qty_6_per",
                                    key: "qty_6_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "4",
                                            dataIndex: "qty_6_per",
                                            key: "qty_6_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "20W",
                                                    dataIndex: "qty_6_per",
                                                    key: "qty_6_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "6x",
                                                            dataIndex: "qty_6_per",
                                                            key: "qty_6_per",
                                                            width: 50,
                                                            align: "right",

                                                            children: [
                                                                {
                                                                    title: "32",
                                                                    dataIndex: "qty_6_per",
                                                                    key: "qty_6_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "27",
                                                                            dataIndex: "qty_6_per",
                                                                            key: "qty_6_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "27P",
                                                                                    dataIndex: "qty_6_per",
                                                                                    key: "qty_6_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_7_per",
                    key: "qty_7_per",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_7_per",
                            key: "qty_7_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "XXL",
                                    dataIndex: "qty_7_per",
                                    key: "qty_7_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "5",
                                            dataIndex: "qty_7_per",
                                            key: "qty_7_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "22W",
                                                    dataIndex: "qty_7_per",
                                                    key: "qty_7_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "7",
                                                            dataIndex: "qty_7_per",
                                                            key: "qty_7_per",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "33",
                                                                    dataIndex: "qty_7_per",
                                                                    key: "qty_7_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "28",
                                                                            dataIndex: "qty_7_per",
                                                                            key: "qty_7_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "28P",
                                                                                    dataIndex: "qty_7_per",
                                                                                    key: "qty_7_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_8_per",
                    key: "qty_8_per",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_8_per",
                            key: "qty_8_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_8_per",
                                    key: "qty_8_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "6",
                                            dataIndex: "qty_8_per",
                                            key: "qty_8_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "24W",
                                                    dataIndex: "qty_8_per",
                                                    key: "qty_8_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "7x",
                                                            dataIndex: "qty_8_per",
                                                            key: "qty_8_per",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "34",
                                                                    dataIndex: "qty_8_per",
                                                                    key: "qty_8_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "29",
                                                                            dataIndex: "qty_8_per",
                                                                            key: "qty_8_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "29P",
                                                                                    dataIndex: "qty_8_per",
                                                                                    key: "qty_8_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }
                            ]
                        }]
                },
                {
                    title: "-",
                    dataIndex: "qty_9_per",
                    key: "qty_9_per",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_9_per",
                            key: "qty_9_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_9_per",
                                    key: "qty_9_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "7",
                                            dataIndex: "qty_9_per",
                                            key: "qty_9_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "26W",
                                                    dataIndex: "qty_9_per",
                                                    key: "qty_9_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "8",
                                                            dataIndex: "qty_9_per",
                                                            key: "qty_9_per",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "35",
                                                                    dataIndex: "qty_9_per",
                                                                    key: "qty_9_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "30",
                                                                            dataIndex: "qty_9_per",
                                                                            key: "qty_9_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "30P",
                                                                                    dataIndex: "qty_9_per",
                                                                                    key: "qty_9_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_10_per",
                    key: "qty_10_per",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_10_per",
                            key: "qty_10_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_10_per",
                                    key: "qty_10_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "8",
                                            dataIndex: "qty_10_per",
                                            key: "qty_10_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "28W",
                                                    dataIndex: "qty_10_per",
                                                    key: "qty_10_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "10",
                                                            dataIndex: "qty_10_per",
                                                            key: "qty_10_per",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "36",
                                                                    dataIndex: "qty_10_per",
                                                                    key: "qty_10_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "31",
                                                                            dataIndex: "qty_10_per",
                                                                            key: "qty_10_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "31P",
                                                                                    dataIndex: "qty_10_per",
                                                                                    key: "qty_10_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_11_per",
                    key: "qty_11_per",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_11_per",
                            key: "qty_11_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_11_per",
                                    key: "qty_11_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "9",
                                            dataIndex: "qty_11_per",
                                            key: "qty_11_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "30W",
                                                    dataIndex: "qty_11_per",
                                                    key: "qty_11_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "12",
                                                            dataIndex: "qty_11_per",
                                                            key: "qty_11_per",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "38",
                                                                    dataIndex: "qty_11_per",
                                                                    key: "qty_11_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "32",
                                                                            dataIndex: "qty_11_per",
                                                                            key: "qty_11_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "32P",
                                                                                    dataIndex: "qty_11_per",
                                                                                    key: "qty_11_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_12_per",
                    key: "qty_12_per",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_12_per",
                            key: "qty_12_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_12_per",
                                    key: "qty_12_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "10",
                                            dataIndex: "qty_12_per",
                                            key: "qty_12_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "32W",
                                                    dataIndex: "qty_12_per",
                                                    key: "qty_12_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "14",
                                                            dataIndex: "qty_12_per",
                                                            key: "qty_12_per",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "40",
                                                                    dataIndex: "qty_12_per",
                                                                    key: "qty_12_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "33",
                                                                            dataIndex: "qty_12_per",
                                                                            key: "qty_12_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "33P",
                                                                                    dataIndex: "qty_12_per",
                                                                                    key: "qty_12_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_13_per",
                    key: "qty_13_per",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_13_per",
                            key: "qty_13_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_13_per",
                                    key: "qty_13_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_13_per",
                                            key: "qty_13_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_13_per",
                                                    key: "qty_13_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "16",
                                                            dataIndex: "qty_13_per",
                                                            key: "qty_13_per",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "42",
                                                                    dataIndex: "qty_13_per",
                                                                    key: "qty_13_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "34",
                                                                            dataIndex: "qty_13_per",
                                                                            key: "qty_13_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "34P",
                                                                                    dataIndex: "qty_13_per",
                                                                                    key: "qty_13_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_14_per",
                    key: "qty_14_per",
                    width: 50,
                    align: "right",

                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_14_per",
                            key: "qty_14_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_14_per",
                                    key: "qty_14_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_14_per",
                                            key: "qty_14_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_14_per",
                                                    key: "qty_14_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "18",
                                                            dataIndex: "qty_14_per",
                                                            key: "qty_14_per",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "44",
                                                                    dataIndex: "qty_14_per",
                                                                    key: "qty_14_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "35",
                                                                            dataIndex: "qty_14_per",
                                                                            key: "qty_14_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "35P",
                                                                                    dataIndex: "qty_14_per",
                                                                                    key: "qty_14_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        }
                                    ]
                                }]
                        },
                    ],
                },
                {
                    title: "-",
                    dataIndex: "qty_15_per",
                    key: "qty_15_per",
                    width: 50,
                    align: "right",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_15_per",
                            key: "qty_15_per",
                            width: 50,
                            align: "right",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_15_per",
                                    key: "qty_15_per",
                                    width: 50,
                                    align: "right",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_15_per",
                                            key: "qty_15_per",
                                            width: 50,
                                            align: "right",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_15_per",
                                                    key: "qty_15_per",
                                                    width: 50,
                                                    align: "right",
                                                    children: [
                                                        {
                                                            title: "20",
                                                            dataIndex: "qty_15_per",
                                                            key: "qty_15_per",
                                                            width: 50,
                                                            align: "right",
                                                            children: [
                                                                {
                                                                    title: "46",
                                                                    dataIndex: "qty_15_per",
                                                                    key: "qty_15_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    children: [
                                                                        {
                                                                            title: "36",
                                                                            dataIndex: "qty_15_per",
                                                                            key: "qty_15_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            children: [
                                                                                {
                                                                                    title: "36P",
                                                                                    dataIndex: "qty_15_per",
                                                                                    key: "qty_15_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }]
                        }
                    ]
                },
                {
                    title: "-",
                    dataIndex: "qty_16_per",
                    key: "qty_16_per",
                    width: 50,
                    align: "right",
                    className: "Border-Right-table border-z-index-1",
                    children: [
                        {
                            title: "-",
                            dataIndex: "qty_16_per",
                            key: "qty_16_per",
                            width: 50,
                            align: "right",
                            className: "Border-Right-table border-z-index-1",
                            children: [
                                {
                                    title: "-",
                                    dataIndex: "qty_16_per",
                                    key: "qty_16_per",
                                    width: 50,
                                    align: "right",
                                    className: "Border-Right-table border-z-index-1",
                                    children: [
                                        {
                                            title: "-",
                                            dataIndex: "qty_16_per",
                                            key: "qty_16_per",
                                            width: 50,
                                            align: "right",
                                            className: "Border-Right-table border-z-index-1",
                                            children: [
                                                {
                                                    title: "-",
                                                    dataIndex: "qty_16_per",
                                                    key: "qty_16_per",
                                                    width: 50,
                                                    align: "right",
                                                    className: "Border-Right-table border-z-index-1",
                                                    children: [
                                                        {
                                                            title: "-",
                                                            dataIndex: "qty_16_per",
                                                            key: "qty_16_per",
                                                            width: 50,
                                                            align: "right",
                                                            className: "Border-Right-table border-z-index-1",
                                                            children: [
                                                                {
                                                                    title: "48",
                                                                    dataIndex: "qty_16_per",
                                                                    key: "qty_16_per",
                                                                    width: 50,
                                                                    align: "right",
                                                                    className: "Border-Right-table border-z-index-1",
                                                                    children: [
                                                                        {
                                                                            title: "37",
                                                                            dataIndex: "qty_16_per",
                                                                            key: "qty_16_per",
                                                                            width: 40,
                                                                            align: "right",
                                                                            className: "Border-Right-table border-z-index-1",
                                                                            children: [
                                                                                {
                                                                                    title: "37P",
                                                                                    dataIndex: "qty_16_per",
                                                                                    key: "qty_16_per",
                                                                                    width: 40,
                                                                                    align: "right",
                                                                                    className: "Border-Right-table border-z-index-1",
                                                                                    render: (text, record) => {
                                                                                        return <>{text}%</>
                                                                                    }
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                },
                                                            ],
                                                        },
                                                    ],
                                                },
                                            ],
                                        },
                                    ],
                                }
                            ]
                        }
                    ]
                },
            ],
        }
    ],
};


export const kidsSizes = [
    { titles: ['T-Jacket', 'Shirt/RTW-P', 'Shirt/RTW-R', 'Y-Adult', 'Kids'], key: "building", width: 75 },
    { titles: ['"2/3"', '1XL', 'XXS', '00', '2'], key: "qty_1" },
    { titles: ['"4/5"', '2XL', 'XS', '0', '3'], key: "qty_2" },
    { titles: ['"6/6X"', '3XL', 'S', '1', '4'], key: "qty_3" },
    { titles: ['"7/8"', '-', 'M', '2', '5'], key: "qty_4" },
    { titles: ['"9/10"', '-', 'L', '3', '6'], key: "qty_5" },
    { titles: ['"11/12"', '-', 'XL', '4', '6x'], key: "qty_6" },
    { titles: ['"13/14"', '-', 'XXL', '5', '7'], key: "qty_7" },
    { titles: ['"15/16"', '-', '-', '6', '8'], key: "qty_8" },
    { titles: ['-', '-', '-', '7', '10'], key: "qty_9" },
    { titles: ['-', '-', '-', '8', '12'], key: "qty_10" },
    { titles: ['-', '-', '-', '9', '14'], key: "qty_11" },
    { titles: ['-', '-', '-', '10', '16'], key: "qty_12" },
    { titles: ['-', '-', '-', '-', '18'], key: "qty_13" },
    { titles: ['-', '-', '-', '-', '20'], key: "qty_14" },
    { titles: ['-', '-', '-', '-', '-'], key: "qty_15" },
    { titles: ['-', '-', '-', '-', '-'], key: "qty_16", border: true },
];

export const womenSizes = [
    { titles: ['Shirt/RTW-P', 'Shirt/RTW-R', 'W-Plus', 'Women'], key: "building", width: 75 },

    { titles: ['1XL', 'XXS', '10W', '22'], key: "qty_1", width: 40 },
    { titles: ['2XL', 'XS', '12W', '23'], key: "qty_2", width: 55 },
    { titles: ['3XL', 'S', '14W', '24'], key: "qty_3", width: 50 },
    { titles: ['-', 'M', '16W', '25'], key: "qty_4" },
    { titles: ['-', 'L', '18W', '26'], key: "qty_5" },
    { titles: ['-', 'XL', '28W', '27'], key: "qty_6" },
    { titles: ['-', 'XXL', '22W', '28'], key: "qty_7" },
    { titles: ['-', '-', '24W', '29'], key: "qty_8" },
    { titles: ['-', '-', '26W', '30'], key: "qty_9" },
    { titles: ['-', '-', '28W', '31'], key: "qty_10" },
    { titles: ['-', '-', '30W', '32'], key: "qty_11" },
    { titles: ['-', '-', '32W', '33'], key: "qty_12" },
    { titles: ['-', '-', '-', '34'], key: "qty_13" },
    { titles: ['-', '-', '-', '35'], key: "qty_14" },
    { titles: ['-', '-', '-', '36'], key: "qty_15" },
    { titles: ['-', '-', '-', '37'], key: "qty_16", border: true },
];

export const menSizes = [
    { titles: ["Shirt/RTW-P", "Shirt/RTW-R", "Men"], key: "building", width: 75 },

    { titles: ["1XL", "XXS", "27"], key: "qty_1", width: 40 },
    { titles: ["2XL", "XS", "28"], key: "qty_2", width: 55 },
    { titles: ["3XL", "S", "29"], key: "qty_3", width: 50 },
    { titles: ["-", "M", "30"], key: "qty_4" },
    { titles: ["-", "L", "31"], key: "qty_5" },
    { titles: ["-", "XL", "32"], key: "qty_6" },
    { titles: ["-", "XXL", "33"], key: "qty_7" },
    { titles: ["-", "-", "34"], key: "qty_8" },
    { titles: ["-", "-", "35"], key: "qty_9" },
    { titles: ["-", "-", "36"], key: "qty_10" },
    { titles: ["-", "-", "38"], key: "qty_11" },
    { titles: ["-", "-", "40"], key: "qty_12" },
    { titles: ["-", "-", "42"], key: "qty_13" },
    { titles: ["-", "-", "44"], key: "qty_14" },
    { titles: ["-", "-", "46"], key: "qty_15" },
    { titles: ["-", "-", "48"], key: "qty_16", border: true },
]

export const allSizes = [
    { titles: ["T-Jacket", "Shirt/RTW-P", "Shirt/RTW-R", "Y-Adult", "W-Plus", "Kids", "Men", "Women",], key: "building", width: 75 },

    { titles: ['"2/3"', "1XL", "XXS", "00", "10W", "2", "27", "22"], key: "qty_1", width: 40 },
    { titles: ['"4/5"', "2XL", "XS", "0", "12W", "3", "28", "23"], key: "qty_2", width: 50 },
    { titles: ['"6/6X"', "3XL", "S", "1", "14W", "4", "29", "24"], key: "qty_3", width: 50 },
    { titles: ['"7/8"', "-", "M", "2", "16W", "5", "30", "25"], key: "qty_4" },
    { titles: ['"9/10"', "-", "L", "3", "18W", "6", "31", "26"], key: "qty_5" },
    { titles: ['"11/12"', "-", "XL", "4", "20W", "6x", "32", "27"], key: "qty_6" },
    { titles: ['"13/14"', "-", "XXL", "5", "22W", "7", "33", "28"], key: "qty_7" },
    { titles: ['"15/16"', "-", "-", "6", "24W", "8", "34", "29"], key: "qty_8" },
    { titles: ["-", "-", "-", "7", "26W", "10", "35", "30"], key: "qty_9" },
    { titles: ["-", "-", "-", "8", "28W", "12", "36", "31"], key: "qty_10" },
    { titles: ["-", "-", "-", "9", "30W", "14", "38", "32"], key: "qty_11" },
    { titles: ["-", "-", "-", "10", "32W", "16", "40", "33"], key: "qty_12" },
    { titles: ["-", "-", "-", "-", "-", "18", "42", "34"], key: "qty_13" },
    { titles: ["-", "-", "-", "-", "-", "20", "44", "35"], key: "qty_14" },
    { titles: ["-", "-", "-", "-", "-", "-", "46", "36"], key: "qty_15" },
    { titles: ["-", "-", "-", "-", "-", "-", "48", "37"], key: "qty_16", border: true },
];



export const allSizesOpOts = [
    { titles: ['"2/3"', "1XL", "XXS", "00", "10W", "2", "27", "22"], width: 40 },
    { titles: ['"4/5"', "2XL", "XS", "0", "12W", "3", "28", "23"], width: 50 },
    { titles: ['"6/6X"', "3XL", "S", "1", "14W", "4", "29", "24"], width: 50 },
    { titles: ['"7/8"', "-", "M", "2", "16W", "5", "30", "25"], },
    { titles: ['"9/10"', "-", "L", "3", "18W", "6", "31", "26"], },
    { titles: ['"11/12"', "-", "XL", "4", "20W", "6x", "32", "27"], },
    { titles: ['"13/14"', "-", "XXL", "5", "22W", "7", "33", "28"], },
    { titles: ['"15/16"', "-", "-", "6", "24W", "8", "34", "29"], },
    { titles: ["-", "-", "-", "7", "26W", "10", "35", "30"], },
    { titles: ["-", "-", "-", "8", "28W", "12", "36", "31"], },
    { titles: ["-", "-", "-", "9", "30W", "14", "38", "32"], },
    { titles: ["-", "-", "-", "10", "32W", "16", "40", "33"] },
    { titles: ["-", "-", "-", "-", "-", "18", "42", "34"], },
    { titles: ["-", "-", "-", "-", "-", "20", "44", "35"] },
    { titles: ["-", "-", "-", "-", "-", "-", "46", "36"], border: true },
    { titles: ["-", "-", "-", "-", "-", "-", "48", "37"], border: true },
];

export const kidsSizesOpOts = [
    { titles: ['"2/3"', '1XL', 'XXS', '00', '2'] },
    { titles: ['"4/5"', '2XL', 'XS', '0', '3'] },
    { titles: ['"6/6X"', '3XL', 'S', '1', '4'] },
    { titles: ['"7/8"', '-', 'M', '2', '5'] },
    { titles: ['"9/10"', '-', 'L', '3', '6'] },
    { titles: ['"11/12"', '-', 'XL', '4', '6x'] },
    { titles: ['"13/14"', '-', 'XXL', '5', '7'] },
    { titles: ['"15/16"', '-', '-', '6', '8'] },
    { titles: ['-', '-', '-', '7', '10'] },
    { titles: ['-', '-', '-', '8', '12'] },
    { titles: ['-', '-', '-', '9', '14'] },
    { titles: ['-', '-', '-', '10', '16'] },
    { titles: ['-', '-', '-', '-', '18'] },
    { titles: ['-', '-', '-', '-', '20'] },
    { titles: ['-', '-', '-', '-', '-'] },
    { titles: ['-', '-', '-', '-', '-'], border: true },
];

export const womenSizesOpOts = [
    { titles: ['1XL', 'XXS', '10W', '22'], width: 40 },
    { titles: ['2XL', 'XS', '12W', '23'], width: 55 },
    { titles: ['3XL', 'S', '14W', '24'], width: 50 },
    { titles: ['-', 'M', '16W', '25'], },
    { titles: ['-', 'L', '18W', '26'], },
    { titles: ['-', 'XL', '28W', '27'], },
    { titles: ['-', 'XXL', '22W', '28'], },
    { titles: ['-', '-', '24W', '29'], },
    { titles: ['-', '-', '26W', '30'], },
    { titles: ['-', '-', '28W', '31'], },
    { titles: ['-', '-', '30W', '32'], },
    { titles: ['-', '-', '32W', '33'], },
    { titles: ['-', '-', '-', '34'], },
    { titles: ['-', '-', '-', '35'], },
    { titles: ['-', '-', '-', '36'], },
    { titles: ['-', '-', '-', '37'], border: true },
];

export const menSizesOpOts = [
    { titles: ["1XL", "XXS", "27"], width: 40 },
    { titles: ["2XL", "XS", "28"], width: 55 },
    { titles: ["3XL", "S", "29"], width: 50 },
    { titles: ["-", "M", "30"], },
    { titles: ["-", "L", "31"], },
    { titles: ["-", "XL", "32"], },
    { titles: ["-", "XXL", "33"], },
    { titles: ["-", "-", "34"], },
    { titles: ["-", "-", "35"], },
    { titles: ["-", "-", "36"] },
    { titles: ["-", "-", "38"] },
    { titles: ["-", "-", "40"] },
    { titles: ["-", "-", "42"] },
    { titles: ["-", "-", "44"] },
    { titles: ["-", "-", "46"] },
    { titles: ["-", "-", "48"], border: true },
]

export const createNestedColumn = (titles, qtyKey, width = 50, extra = {}) => {
    const align = qtyKey === "building" ? "left" : "right"; // 👈 yahan

    let node = {
        title: titles[titles.length - 1],
        dataIndex: qtyKey,
        key: qtyKey,
        width,
        align,
        render: extra.render,
        className: extra.className,
    };

    for (let i = titles.length - 2; i >= 0; i--) {
        node = {
            title: titles[i],
            dataIndex: qtyKey,
            key: qtyKey,
            width,
            align, // 👈 yahan bhi
            className: extra.className,
            children: [node],
        };
    }

    return node;
};